import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 border-t border-gold/20 py-16 text-center" data-id="element-73">
      <div className="container mx-auto px-6" data-id="element-74">
        <h2 className="font-display font-bold text-3xl text-gold tracking-widest mb-4" data-id="element-75">
          🎹 PIANO LISTO™
        </h2>

        <p className="font-accent italic text-xl text-gray-300 mb-2" data-id="element-76">
          El sistema N°1 de clases para profesores de piano en Argentina.
        </p>
        <p className="text-gray-400 mb-12" data-id="element-77">
          Porque enseñar piano no debería costarte todos los domingos del año.
        </p>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm text-gray-300 mb-12" data-id="element-78">
          <a href="mailto:contacto@pianolisto.com.ar" className="hover:text-gold transition-colors" data-id="element-79">
            📧 contacto@pianolisto.com.ar
          </a>
          <span className="hidden md:inline text-gold/30" data-id="element-80">·</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-81">
            📲 @pianolisto
          </a>
          <span className="hidden md:inline text-gold/30" data-id="element-82">·</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-83">
            🌐 www.pianolisto.com
          </a>
        </div>

        <div className="text-xs text-gray-500 space-y-2 border-t border-white/10 pt-8 max-w-2xl mx-auto" data-id="element-84">
          <p data-id="element-85">© Piano Listo™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-86">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}